import Template from "backbone/projects/templates/new.js.hamlc"
import ClipPublicationView from "backbone/projects/views/clip_publication_view.js"

export default class NewProjectView extends Backbone.View
  className: "new-project-form-wrapper"

  events:
    "submit form"                    : "addProject"
    "click .js-new-cancel"           : "remove"
    "click .js-toggle-url-based"     : "toggleUrlBased"
    "click .js-add-clip-publication" : "addClipPublication"
    "change .js-pdf-input"           : "attachPdf"

  initialize: ->
    @onCreate = @options.onCreate
    @onCancel = @options.onCancel
    @urlBased = @options.urlBased

  render: ->
    html = Template(urlBased: @urlBased, newClipPub: @newClipPub, submitButtonText: @submitButtonText())

    @$el.html(html)
    contently.ui.setup_validation @$el

    if !@urlBased
      @clipPublicationView = new ClipPublicationView(el: @$el.find(".js-clip-publication-search"))
      @$uploadedFile = @$el.find(".js-uploaded-file")
    else
      @newClipPub = false
      @clipPublicationView.remove() if @clipPublicationView

    this

  remove: ->
    @onCancel() if @onCancel
    super()

  addClipPublication: ->
    @newClipPub = true
    @render()

  attachPdf: ->
    pdfInput = @$el.find(".js-pdf-input").get(0)
    if Modernizr.filereader && !!pdfInput.files && pdfInput.files.length > 0
      @$uploadedFile.find(".js-filename").text(pdfInput.files[0].name)
      @$uploadedFile.show()

  toggleUrlBased: ->
    @urlBased = !@urlBased
    @render()

  submitButtonText: ->
    if @urlBased
      "Get details"
    else
      "Start project"

  next: ->
    @$el.find("form").submit()

  addProject: (e) ->
    e.preventDefault()
    @$form = $(e.target)
    if @$form.parsley().validate()
      @$el.find(".maskable").maskLoading()
      formData = new FormData(e.target)
      $.ajax
        url: @$form.attr('action')
        data: formData
        processData: false
        contentType: false
        type: 'POST'
        dataType: 'json'
        success: (projectData) =>
          @onCreate(projectData)
          @remove()
        error: (xhr, status, error) =>
          @$el.find(".maskable").unmaskLoading()
          if xhr.status == 503 || xhr.status == 504
            @onCreate({url: @$form.find("input[name='clip[url]']").val()})
            @remove()
          else
            contently.flash.alert("Sorry, there was an problem starting your project.")



// WEBPACK FOOTER //
// ./app/javascript/backbone/projects/views/new_project_view.js.coffee